<template>
  <div>
    <b-modal
      id="select-cover"
      :modal-class="'default-modal'"
      :hide-footer="true"
      @hidden="hidden"
      @shown="shown"
    >
      <template v-slot:modal-title>
        Selecione uma das opções
      </template>

      <template v-slot:default>
        <AlertWraper
          class="text-left"
          :content="errors"
          type="error"
        />
        <div v-if="loader && assets.length == 0">
          <Loader
            color="color2"
            size="medium"
          />
        </div>
        <div v-else-if="assets.length > 0">
          <div
            class="cover-list d-flex flex-wrap justify-content-center"
          >
            <div
              class="cover-item"
              v-for="asset in assets"
              :key="asset.id"
            >
              <label>
                <input
                  type="radio"
                  v-model="selected"
                  @change="selectCover(asset)"
                />
                <span>
                  <img :src="asset.url" alt="Cover" />
                </span>
              </label>
            </div>
          </div>
          <div class="text-center mt-3" v-if="isLoadMoreVisible">
            <Button
              class="btn btn-sm btn-outline-color2"
              :loading="loader"
              @click="loadMore"
            >
              Carregar mais
            </Button>
          </div>
        </div>
        <div v-else>
          <p class="text-center">
            Não foram encontradas capas para seleção
          </p>
        </div>

        <div>

        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

import AssetsService from '@/modules/assets/services/assets-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'CoverSelectModal',
  components: {
    AlertWraper,
    Button,
    Loader
  },
  props: ['type'],
  data () {
    return {
      assets: [],
      selected: '',
      loader: false,
      isLoadMoreVisible: true,
      page: 1,
      errors: null
    }
  },
  methods: {
    shown () {
      this.getAssets()
    },
    hidden () {
      this.assets = []
      this.selected = ''
      this.page = 1
    },
    async getAssets () {
      this.loader = true
      const type = this.type ? this.type : 'default_cover'
      try {
        const assets = await AssetsService.getAssets({
          type: type,
          page: this.page
        })
        this.assets = [...this.assets, ...assets]
        if (assets.length === 0) this.isLoadMoreVisible = false
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getAssets()
    },
    selectCover (cover) {
      this.$emit('cover-selected', cover)
      this.$bvModal.hide('select-cover')
    }
  }
}
</script>

<style lang="scss" scoped>
.cover-item {

  label {
    cursor: pointer;
    margin-bottom: 0;
  }

  input {
    display: none;
  }

  input + span {
    display: inline-block;
    max-width: 200px;
    padding: 15px;
    border-radius: 10px;

    img {
      max-width: 100%;
      max-height: 100%;
      border-radius: 10px;
    }
  }

  input:checked + span, label:hover span {
    background: $color2;
  }
}
</style>
